import type { Device } from '../store/store';

export const DEVICES: Device[] = [
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'ipad-air-space-gray-landscape',
    imageUrl: '/devices/apple/ipad-air-space-gray-landscape.png',
    model: 'iPad Air',
    orientation: 'Landscape',
    viewportHeight: 1640,
    viewportOffsetX: 140,
    viewportOffsetY: 140,
    viewportWidth: 2360,
  },
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'ipad-air-space-gray-portrait',
    imageUrl: '/devices/apple/ipad-air-space-gray-portrait.png',
    model: 'iPad Air',
    orientation: 'Portrait',
    viewportHeight: 2360,
    viewportOffsetX: 140,
    viewportOffsetY: 140,
    viewportWidth: 1640,
  },
  {
    brand: 'Apple',
    color: 'Starlight',
    id: 'ipad-mini-starlight-landscape',
    imageUrl: '/devices/apple/ipad-mini-starlight-landscape.png',
    model: 'iPad Mini',
    orientation: 'Landscape',
    viewportHeight: 1536,
    viewportOffsetX: 251,
    viewportOffsetY: 122,
    viewportWidth: 2048,
  },
  {
    brand: 'Apple',
    color: 'Starlight',
    id: 'ipad-mini-starlight-portrait',
    imageUrl: '/devices/apple/ipad-mini-starlight-portrait.png',
    model: 'iPad Mini',
    orientation: 'Portrait',
    viewportHeight: 2048,
    viewportOffsetX: 122,
    viewportOffsetY: 251,
    viewportWidth: 1536,
  },
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'ipad-pro-11-space-gray-landscape',
    imageUrl: '/devices/apple/ipad-pro-11-space-gray-landscape.png',
    model: 'iPad Pro 11',
    orientation: 'Landscape',
    viewportHeight: 1668,
    viewportOffsetX: 111,
    viewportOffsetY: 111,
    viewportWidth: 2388,
  },
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'ipad-pro-11-space-gray-portrait',
    imageUrl: '/devices/apple/ipad-pro-11-space-gray-portrait.png',
    model: 'iPad Pro 11',
    orientation: 'Portrait',
    viewportHeight: 2388,
    viewportOffsetX: 111,
    viewportOffsetY: 111,
    viewportWidth: 1668,
  },
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'ipad-pro-12-9-space-gray-landscape',
    imageUrl: '/devices/apple/ipad-pro-12-9-space-gray-landscape.png',
    model: 'iPad Pro 12.9',
    orientation: 'Landscape',
    viewportHeight: 2048,
    viewportOffsetX: 114,
    viewportOffsetY: 121,
    viewportWidth: 2732,
  },
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'ipad-pro-12-9-space-gray-portrait',
    imageUrl: '/devices/apple/ipad-pro-12-9-space-gray-portrait.png',
    model: 'iPad Pro 12.9',
    orientation: 'Portrait',
    viewportHeight: 2732,
    viewportOffsetX: 121,
    viewportOffsetY: 114,
    viewportWidth: 2048,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'ipad-silver-landscape',
    imageUrl: '/devices/apple/ipad-silver-landscape.png',
    model: 'iPad',
    orientation: 'Landscape',
    viewportHeight: 1620,
    viewportOffsetX: 250,
    viewportOffsetY: 110,
    viewportWidth: 2160,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'ipad-silver-portrait',
    imageUrl: '/devices/apple/ipad-silver-portrait.png',
    model: 'iPad',
    orientation: 'Portrait',
    viewportHeight: 2160,
    viewportOffsetX: 110,
    viewportOffsetY: 250,
    viewportWidth: 1620,
  },
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'iphone-11-portrait',
    imageUrl: '/devices/apple/iphone-11-portrait.png',
    model: 'iPhone 11',
    orientation: 'Portrait',
    viewportHeight: 1792,
    viewportOffsetX: 90,
    viewportOffsetY: 80,
    viewportWidth: 828,
  },
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'iphone-11-pro-max-portrait',
    imageUrl: '/devices/apple/iphone-11-pro-max-portrait.png',
    model: 'iPhone 11 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2688,
    viewportOffsetX: 110.5,
    viewportOffsetY: 100,
    viewportWidth: 1242,
  },
  {
    brand: 'Apple',
    color: 'Space Gray',
    id: 'iphone-11-pro-portrait',
    imageUrl: '/devices/apple/iphone-11-pro-portrait.png',
    model: 'iPhone 11 Pro',
    orientation: 'Portrait',
    viewportHeight: 2436,
    viewportOffsetX: 120,
    viewportOffsetY: 110,
    viewportWidth: 1125,
  },
  {
    brand: 'Apple',
    color: 'White',
    id: 'iphone-12-mini-white-portrait',
    imageUrl: '/devices/apple/iphone-12-mini-white-portrait.png',
    model: 'iPhone 12 Mini',
    orientation: 'Portrait',
    viewportHeight: 2340,
    viewportOffsetX: 122.5,
    viewportOffsetY: 138,
    viewportWidth: 1080,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-12-pro-max-silver-portrait',
    imageUrl: '/devices/apple/iphone-12-pro-max-silver-portrait.png',
    model: 'iPhone 12 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2778,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 1284,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-12-pro-silver-landscape',
    imageUrl: '/devices/apple/iphone-12-pro-silver-landscape.png',
    model: 'iPhone 12 Pro',
    orientation: 'Landscape',
    viewportHeight: 1170,
    viewportOffsetX: 90,
    viewportOffsetY: 100,
    viewportWidth: 2532,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-12-pro-silver-portrait',
    imageUrl: '/devices/apple/iphone-12-pro-silver-portrait.png',
    model: 'iPhone 12 Pro',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 100,
    viewportOffsetY: 90,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'White',
    id: 'iphone-12-white-portrait',
    imageUrl: '/devices/apple/iphone-12-white-portrait.png',
    model: 'iPhone 12',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 100,
    viewportOffsetY: 90,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Midnight',
    id: 'iphone-13-midnight',
    imageUrl: '/devices/apple/iphone-13-midnight.png',
    model: 'iPhone 13',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 115,
    viewportOffsetY: 84,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Midnight',
    id: 'iphone-13-mini-midnight',
    imageUrl: '/devices/apple/iphone-13-mini-midnight.png',
    model: 'iPhone 13 Mini',
    orientation: 'Portrait',
    viewportHeight: 2340,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 1080,
  },
  {
    brand: 'Apple',
    color: 'Starlight',
    id: 'iphone-13-mini-starlight',
    imageUrl: '/devices/apple/iphone-13-mini-starlight.png',
    model: 'iPhone 13 Mini',
    orientation: 'Portrait',
    viewportHeight: 2340,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 1080,
  },
  {
    brand: 'Apple',
    color: 'Graphite',
    id: 'iphone-13-pro-graphite-landscape',
    imageUrl: '/devices/apple/iphone-13-pro-graphite-landscape.png',
    model: 'iPhone 13 Pro',
    orientation: 'Landscape',
    viewportHeight: 1170,
    viewportOffsetX: 84,
    viewportOffsetY: 115,
    viewportWidth: 2532,
  },
  {
    brand: 'Apple',
    color: 'Graphite',
    id: 'iphone-13-pro-graphite-portrait',
    imageUrl: '/devices/apple/iphone-13-pro-graphite-portrait.png',
    model: 'iPhone 13 Pro',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 115,
    viewportOffsetY: 84,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Graphite',
    id: 'iphone-13-pro-max-graphite-portrait',
    imageUrl: '/devices/apple/iphone-13-pro-max-graphite-portrait.png',
    model: 'iPhone 13 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2778,
    viewportOffsetX: 108,
    viewportOffsetY: 111,
    viewportWidth: 1284,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-13-pro-max-silver-portrait',
    imageUrl: '/devices/apple/iphone-13-pro-max-silver-portrait.png',
    model: 'iPhone 13 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2778,
    viewportOffsetX: 108,
    viewportOffsetY: 111,
    viewportWidth: 1284,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-13-pro-silver-landscape',
    imageUrl: '/devices/apple/iphone-13-pro-silver-landscape.png',
    model: 'iPhone 13 Pro',
    orientation: 'Landscape',
    viewportHeight: 1170,
    viewportOffsetX: 84,
    viewportOffsetY: 115,
    viewportWidth: 2532,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-13-pro-silver-portrait',
    imageUrl: '/devices/apple/iphone-13-pro-silver-portrait.png',
    model: 'iPhone 13 Pro',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 115,
    viewportOffsetY: 84,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Starlight',
    id: 'iphone-13-starlight',
    imageUrl: '/devices/apple/iphone-13-starlight.png',
    model: 'iPhone 13',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 115,
    viewportOffsetY: 84,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Blue',
    id: 'iphone-14-blue-landscape',
    imageUrl: '/devices/apple/iphone-14-blue-landscape.png',
    model: 'iPhone 14',
    orientation: 'Landscape',
    viewportHeight: 1170,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 2532,
  },
  {
    brand: 'Apple',
    color: 'Blue',
    id: 'iphone-14-blue-portrait',
    imageUrl: '/devices/apple/iphone-14-blue-portrait.png',
    model: 'iPhone 14',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Midnight',
    id: 'iphone-14-midnight-landscape',
    imageUrl: '/devices/apple/iphone-14-midnight-landscape.png',
    model: 'iPhone 14',
    orientation: 'Landscape',
    viewportHeight: 1170,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 2532,
  },
  {
    brand: 'Apple',
    color: 'Midnight',
    id: 'iphone-14-midnight-portrait',
    imageUrl: '/devices/apple/iphone-14-midnight-portrait.png',
    model: 'iPhone 14',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Blue',
    id: 'iphone-14-plus-blue-landscape',
    imageUrl: '/devices/apple/iphone-14-plus-blue-landscape.png',
    model: 'iPhone 14 Plus',
    orientation: 'Landscape',
    viewportHeight: 1284,
    viewportOffsetX: 100,
    viewportOffsetY: 90,
    viewportWidth: 2778,
  },
  {
    brand: 'Apple',
    color: 'Blue',
    id: 'iphone-14-plus-blue-portrait',
    imageUrl: '/devices/apple/iphone-14-plus-blue-portrait.png',
    model: 'iPhone 14 Plus',
    orientation: 'Portrait',
    viewportHeight: 2778,
    viewportOffsetX: 90,
    viewportOffsetY: 100,
    viewportWidth: 1284,
  },
  {
    brand: 'Apple',
    color: 'Midnight',
    id: 'iphone-14-plus-midnight-landscape',
    imageUrl: '/devices/apple/iphone-14-plus-midnight-landscape.png',
    model: 'iPhone 14 Plus',
    orientation: 'Landscape',
    viewportHeight: 1284,
    viewportOffsetX: 100,
    viewportOffsetY: 90,
    viewportWidth: 2778,
  },
  {
    brand: 'Apple',
    color: 'Midnight',
    id: 'iphone-14-plus-midnight-portrait',
    imageUrl: '/devices/apple/iphone-14-plus-midnight-portrait.png',
    model: 'iPhone 14 Plus',
    orientation: 'Portrait',
    viewportHeight: 2778,
    viewportOffsetX: 90,
    viewportOffsetY: 100,
    viewportWidth: 1284,
  },
  {
    brand: 'Apple',
    color: 'Purple',
    id: 'iphone-14-plus-purple-landscape',
    imageUrl: '/devices/apple/iphone-14-plus-purple-landscape.png',
    model: 'iPhone 14 Plus',
    orientation: 'Landscape',
    viewportHeight: 1284,
    viewportOffsetX: 100,
    viewportOffsetY: 90,
    viewportWidth: 2778,
  },
  {
    brand: 'Apple',
    color: 'Purple',
    id: 'iphone-14-plus-purple-portrait',
    imageUrl: '/devices/apple/iphone-14-plus-purple-portrait.png',
    model: 'iPhone 14 Plus',
    orientation: 'Portrait',
    viewportHeight: 2778,
    viewportOffsetX: 90,
    viewportOffsetY: 100,
    viewportWidth: 1284,
  },
  {
    brand: 'Apple',
    color: 'Red',
    id: 'iphone-14-plus-red-landscape',
    imageUrl: '/devices/apple/iphone-14-plus-red-landscape.png',
    model: 'iPhone 14 Plus',
    orientation: 'Landscape',
    viewportHeight: 1284,
    viewportOffsetX: 100,
    viewportOffsetY: 90,
    viewportWidth: 2778,
  },
  {
    brand: 'Apple',
    color: 'Red',
    id: 'iphone-14-plus-red-portrait',
    imageUrl: '/devices/apple/iphone-14-plus-red-portrait.png',
    model: 'iPhone 14 Plus',
    orientation: 'Portrait',
    viewportHeight: 2778,
    viewportOffsetX: 90,
    viewportOffsetY: 100,
    viewportWidth: 1284,
  },
  {
    brand: 'Apple',
    color: 'Starlight',
    id: 'iphone-14-plus-starlight-landscape',
    imageUrl: '/devices/apple/iphone-14-plus-starlight-landscape.png',
    model: 'iPhone 14 Plus',
    orientation: 'Landscape',
    viewportHeight: 1284,
    viewportOffsetX: 100,
    viewportOffsetY: 90,
    viewportWidth: 2778,
  },
  {
    brand: 'Apple',
    color: 'Starlight',
    id: 'iphone-14-plus-starlight-portrait',
    imageUrl: '/devices/apple/iphone-14-plus-starlight-portrait.png',
    model: 'iPhone 14 Plus',
    orientation: 'Portrait',
    viewportHeight: 2778,
    viewportOffsetX: 90,
    viewportOffsetY: 100,
    viewportWidth: 1284,
  },
  {
    brand: 'Apple',
    color: 'Deep Purple',
    id: 'iphone-14-pro-deep-purple-landscape',
    imageUrl: '/devices/apple/iphone-14-pro-deep-purple-landscape.png',
    model: 'iPhone 14 Pro',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Deep Purple',
    id: 'iphone-14-pro-deep-purple-portrait',
    imageUrl: '/devices/apple/iphone-14-pro-deep-purple-portrait.png',
    model: 'iPhone 14 Pro',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Gold',
    id: 'iphone-14-pro-gold-landscape',
    imageUrl: '/devices/apple/iphone-14-pro-gold-landscape.png',
    model: 'iPhone 14 Pro',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Gold',
    id: 'iphone-14-pro-gold-portrait',
    imageUrl: '/devices/apple/iphone-14-pro-gold-portrait.png',
    model: 'iPhone 14 Pro',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Deep Purple',
    id: 'iphone-14-pro-max-deep-purple-landscape',
    imageUrl: '/devices/apple/iphone-14-pro-max-deep-purple-landscape.png',
    model: 'iPhone 14 Pro Max',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 70,
    viewportOffsetY: 80,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Deep Purple',
    id: 'iphone-14-pro-max-deep-purple-portrait',
    imageUrl: '/devices/apple/iphone-14-pro-max-deep-purple-portrait.png',
    model: 'iPhone 14 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 80,
    viewportOffsetY: 70,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Gold',
    id: 'iphone-14-pro-max-gold-landscape',
    imageUrl: '/devices/apple/iphone-14-pro-max-gold-landscape.png',
    model: 'iPhone 14 Pro Max',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 70,
    viewportOffsetY: 80,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Gold',
    id: 'iphone-14-pro-max-gold-portrait',
    imageUrl: '/devices/apple/iphone-14-pro-max-gold-portrait.png',
    model: 'iPhone 14 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 80,
    viewportOffsetY: 70,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-14-pro-max-silver-landscape',
    imageUrl: '/devices/apple/iphone-14-pro-max-silver-landscape.png',
    model: 'iPhone 14 Pro Max',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 70,
    viewportOffsetY: 80,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-14-pro-max-silver-portrait',
    imageUrl: '/devices/apple/iphone-14-pro-max-silver-portrait.png',
    model: 'iPhone 14 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 80,
    viewportOffsetY: 70,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Space Black',
    id: 'iphone-14-pro-max-space-black-landscape',
    imageUrl: '/devices/apple/iphone-14-pro-max-space-black-landscape.png',
    model: 'iPhone 14 Pro Max',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 70,
    viewportOffsetY: 80,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Space Black',
    id: 'iphone-14-pro-max-space-black-portrait',
    imageUrl: '/devices/apple/iphone-14-pro-max-space-black-portrait.png',
    model: 'iPhone 14 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 80,
    viewportOffsetY: 70,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-14-pro-silver-landscape',
    imageUrl: '/devices/apple/iphone-14-pro-silver-landscape.png',
    model: 'iPhone 14 Pro',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Silver',
    id: 'iphone-14-pro-silver-portrait',
    imageUrl: '/devices/apple/iphone-14-pro-silver-portrait.png',
    model: 'iPhone 14 Pro',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Space Black',
    id: 'iphone-14-pro-space-black-landscape',
    imageUrl: '/devices/apple/iphone-14-pro-space-black-landscape.png',
    model: 'iPhone 14 Pro',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Space Black',
    id: 'iphone-14-pro-space-black-portrait',
    imageUrl: '/devices/apple/iphone-14-pro-space-black-portrait.png',
    model: 'iPhone 14 Pro',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 80,
    viewportOffsetY: 80,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Purple',
    id: 'iphone-14-purple-landscape',
    imageUrl: '/devices/apple/iphone-14-purple-landscape.png',
    model: 'iPhone 14',
    orientation: 'Landscape',
    viewportHeight: 1170,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 2532,
  },
  {
    brand: 'Apple',
    color: 'Purple',
    id: 'iphone-14-purple-portrait',
    imageUrl: '/devices/apple/iphone-14-purple-portrait.png',
    model: 'iPhone 14',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Red',
    id: 'iphone-14-red-landscape',
    imageUrl: '/devices/apple/iphone-14-red-landscape.png',
    model: 'iPhone 14',
    orientation: 'Landscape',
    viewportHeight: 1170,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 2532,
  },
  {
    brand: 'Apple',
    color: 'Red',
    id: 'iphone-14-red-portrait',
    imageUrl: '/devices/apple/iphone-14-red-portrait.png',
    model: 'iPhone 14',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Starlight',
    id: 'iphone-14-starlight-landscape',
    imageUrl: '/devices/apple/iphone-14-starlight-landscape.png',
    model: 'iPhone 14',
    orientation: 'Landscape',
    viewportHeight: 1170,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 2532,
  },
  {
    brand: 'Apple',
    color: 'Starlight',
    id: 'iphone-14-starlight-portrait',
    imageUrl: '/devices/apple/iphone-14-starlight-portrait.png',
    model: 'iPhone 14',
    orientation: 'Portrait',
    viewportHeight: 2532,
    viewportOffsetX: 100,
    viewportOffsetY: 100,
    viewportWidth: 1170,
  },
  {
    brand: 'Apple',
    color: 'Black',
    id: 'iphone-15-black-landscape',
    imageUrl: '/devices/apple/iphone-15-black-landscape.png',
    model: 'iPhone 15',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Black',
    id: 'iphone-15-black-portrait',
    imageUrl: '/devices/apple/iphone-15-black-portrait.png',
    model: 'iPhone 15',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Blue',
    id: 'iphone-15-blue-landscape',
    imageUrl: '/devices/apple/iphone-15-blue-landscape.png',
    model: 'iPhone 15',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Blue',
    id: 'iphone-15-blue-portrait',
    imageUrl: '/devices/apple/iphone-15-blue-portrait.png',
    model: 'iPhone 15',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Green',
    id: 'iphone-15-green-landscape',
    imageUrl: '/devices/apple/iphone-15-green-landscape.png',
    model: 'iPhone 15',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Green',
    id: 'iphone-15-green-portrait',
    imageUrl: '/devices/apple/iphone-15-green-portrait.png',
    model: 'iPhone 15',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Pink',
    id: 'iphone-15-pink-landscape',
    imageUrl: '/devices/apple/iphone-15-pink-landscape.png',
    model: 'iPhone 15',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Pink',
    id: 'iphone-15-pink-portrait',
    imageUrl: '/devices/apple/iphone-15-pink-portrait.png',
    model: 'iPhone 15',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Black',
    id: 'iphone-15-plus-black-landscape',
    imageUrl: '/devices/apple/iphone-15-plus-black-landscape.png',
    model: 'iPhone 15 Plus',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Black',
    id: 'iphone-15-plus-black-portrait',
    imageUrl: '/devices/apple/iphone-15-plus-black-portrait.png',
    model: 'iPhone 15 Plus',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Blue',
    id: 'iphone-15-plus-blue-landscape',
    imageUrl: '/devices/apple/iphone-15-plus-blue-landscape.png',
    model: 'iPhone 15 Plus',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Blue',
    id: 'iphone-15-plus-blue-portrait',
    imageUrl: '/devices/apple/iphone-15-plus-blue-portrait.png',
    model: 'iPhone 15 Plus',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Green',
    id: 'iphone-15-plus-green-landscape',
    imageUrl: '/devices/apple/iphone-15-plus-green-landscape.png',
    model: 'iPhone 15 Plus',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Green',
    id: 'iphone-15-plus-green-portrait',
    imageUrl: '/devices/apple/iphone-15-plus-green-portrait.png',
    model: 'iPhone 15 Plus',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Pink',
    id: 'iphone-15-plus-pink-landscape',
    imageUrl: '/devices/apple/iphone-15-plus-pink-landscape.png',
    model: 'iPhone 15 Plus',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Pink',
    id: 'iphone-15-plus-pink-portrait',
    imageUrl: '/devices/apple/iphone-15-plus-pink-portrait.png',
    model: 'iPhone 15 Plus',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Yellow',
    id: 'iphone-15-plus-yellow-landscape',
    imageUrl: '/devices/apple/iphone-15-plus-yellow-landscape.png',
    model: 'iPhone 15 Plus',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Yellow',
    id: 'iphone-15-plus-yellow-portrait',
    imageUrl: '/devices/apple/iphone-15-plus-yellow-portrait.png',
    model: 'iPhone 15 Plus',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Black Titanium',
    id: 'iphone-15-pro-black-titanium-landscape',
    imageUrl: '/devices/apple/iphone-15-pro-black-titanium-landscape.png',
    model: 'iPhone 15 Pro',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Black Titanium',
    id: 'iphone-15-pro-black-titanium-portrait',
    imageUrl: '/devices/apple/iphone-15-pro-black-titanium-portrait.png',
    model: 'iPhone 15 Pro',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Blue Titanium',
    id: 'iphone-15-pro-blue-titanium-landscape',
    imageUrl: '/devices/apple/iphone-15-pro-blue-titanium-landscape.png',
    model: 'iPhone 15 Pro',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Blue Titanium',
    id: 'iphone-15-pro-blue-titanium-portrait',
    imageUrl: '/devices/apple/iphone-15-pro-blue-titanium-portrait.png',
    model: 'iPhone 15 Pro',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Black Titanium',
    id: 'iphone-15-pro-max-black-titanium-landscape',
    imageUrl: '/devices/apple/iphone-15-pro-max-black-titanium-landscape.png',
    model: 'iPhone 15 Pro Max',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Black Titanium',
    id: 'iphone-15-pro-max-black-titanium-portrait',
    imageUrl: '/devices/apple/iphone-15-pro-max-black-titanium-portrait.png',
    model: 'iPhone 15 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Blue Titanium',
    id: 'iphone-15-pro-max-blue-titanium-landscape',
    imageUrl: '/devices/apple/iphone-15-pro-max-blue-titanium-landscape.png',
    model: 'iPhone 15 Pro Max',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Blue Titanium',
    id: 'iphone-15-pro-max-blue-titanium-portrait',
    imageUrl: '/devices/apple/iphone-15-pro-max-blue-titanium-portrait.png',
    model: 'iPhone 15 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Natural Titanium',
    id: 'iphone-15-pro-max-natural-titanium-landscape',
    imageUrl: '/devices/apple/iphone-15-pro-max-natural-titanium-landscape.png',
    model: 'iPhone 15 Pro Max',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'Natural Titanium',
    id: 'iphone-15-pro-max-natural-titanium-portrait',
    imageUrl: '/devices/apple/iphone-15-pro-max-natural-titanium-portrait.png',
    model: 'iPhone 15 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'White Titanium',
    id: 'iphone-15-pro-max-white-titanium-landscape',
    imageUrl: '/devices/apple/iphone-15-pro-max-white-titanium-landscape.png',
    model: 'iPhone 15 Pro Max',
    orientation: 'Landscape',
    viewportHeight: 1290,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2796,
  },
  {
    brand: 'Apple',
    color: 'White Titanium',
    id: 'iphone-15-pro-max-white-titanium-portrait',
    imageUrl: '/devices/apple/iphone-15-pro-max-white-titanium-portrait.png',
    model: 'iPhone 15 Pro Max',
    orientation: 'Portrait',
    viewportHeight: 2796,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1290,
  },
  {
    brand: 'Apple',
    color: 'Natural Titanium',
    id: 'iphone-15-pro-natural-titanium-landscape',
    imageUrl: '/devices/apple/iphone-15-pro-natural-titanium-landscape.png',
    model: 'iPhone 15 Pro',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Natural Titanium',
    id: 'iphone-15-pro-natural-titanium-portrait',
    imageUrl: '/devices/apple/iphone-15-pro-natural-titanium-portrait.png',
    model: 'iPhone 15 Pro',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'White Titanium',
    id: 'iphone-15-pro-white-titanium-landscape',
    imageUrl: '/devices/apple/iphone-15-pro-white-titanium-landscape.png',
    model: 'iPhone 15 Pro',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'White Titanium',
    id: 'iphone-15-pro-white-titanium-portrait',
    imageUrl: '/devices/apple/iphone-15-pro-white-titanium-portrait.png',
    model: 'iPhone 15 Pro',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
  {
    brand: 'Apple',
    color: 'Yellow',
    id: 'iphone-15-yellow-landscape',
    imageUrl: '/devices/apple/iphone-15-yellow-landscape.png',
    model: 'iPhone 15',
    orientation: 'Landscape',
    viewportHeight: 1179,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 2556,
  },
  {
    brand: 'Apple',
    color: 'Yellow',
    id: 'iphone-15-yellow-portrait',
    imageUrl: '/devices/apple/iphone-15-yellow-portrait.png',
    model: 'iPhone 15',
    orientation: 'Portrait',
    viewportHeight: 2556,
    viewportOffsetX: 120,
    viewportOffsetY: 120,
    viewportWidth: 1179,
  },
];
